/**
 * @fileoverview DELETE handler for the "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/post_launch_draft" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftCacheKeys } from "./constants";
import type {
  DeleteEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftProps,
  DeleteLandingPagePostLaunchDraftResult,
  DeleteLandingPagePostLaunchDraftResultErrors,
} from "./types";

export const deleteLandingPagePostLaunchDraft = reactQueryMutationAdapter(
  deleteEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftCacheKeys,
  createMutationFetcherFunctionWithShadowError<DeleteLandingPagePostLaunchDraftResultErrors>()(
    ({
      appGroupId,
      landingPageBsonId,
      postLaunchDraftId,
    }: DeleteEngagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraftProps): Promise<DeleteLandingPagePostLaunchDraftResult> => {
      return fetch(
        `/engagement/landing_pages/${appGroupId}/${landingPageBsonId}/post_launch_draft`,
        "DELETE",
        { post_launch_draft_id: postLaunchDraftId },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
